module.exports = __webpack_public_path__ + "img/44.c2565b47.jpg";